/**
 * BFP-1144 — local mirror of `@brushfire/types` `PublishChannelContent` / `CHANNEL_CONTENT_LIMITS`
 * (CI clones shared from `dev-10` without these exports).
 */

export interface SmsChannelContent {
  message: string
}

export interface EmailChannelContent {
  subject: string
  /** Sanitized rich-text HTML (bold, italic, underline, lists, links). */
  bodyHtml: string
}

export interface PushChannelContent {
  title: string
  message: string
}

export interface ChannelContentDraft {
  sms?: SmsChannelContent
  email?: EmailChannelContent
  push?: PushChannelContent
}

export type ChannelContentKey = keyof ChannelContentDraft

export type ChannelContentByKey = {
  sms: SmsChannelContent
  email: EmailChannelContent
  push: PushChannelContent
}

/** PATCH shape — `null` removes a channel's customization (restores the system default). */
export type ChannelContentPatch = {
  [K in ChannelContentKey]?: ChannelContentByKey[K] | null
}

export const CHANNEL_CONTENT_LIMITS = {
  smsMessage: 250,
  emailSubject: 100,
  emailBody: 250,
  pushTitle: 50,
  pushMessage: 250,
} as const

export const CHANNEL_CONTENT_KEYS: readonly ChannelContentKey[] = ['sms', 'email', 'push']

/** True when at least one channel has customized copy (empty `{}` is not stored content). */
export function hasStoredChannelContent(
  content: ChannelContentDraft | null | undefined,
): boolean {
  if (content == null) return false
  return CHANNEL_CONTENT_KEYS.some((key) => content[key] != null)
}
